module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "con"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#con"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflusha"
  }, [_vm._v("Craig G. Bartholomew")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Director of the Kirby Laing Institute for Christian Ethics")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Tyndale House, Cambridge")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Hans Boersma")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("J. I. Packer Professor of Theology")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Regent College")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("S. A. Cummins")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Professor of Religious Studies")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Trinity Western University")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Peter Enns")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Abram S. Clemens Professor of Biblical Studies")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Eastern University")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Stephen E. Fowl")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Professor, Department of Theology")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Loyola University Maryland")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Joel B. Green")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Provost, Dean of the School of Theology, and Professor of New Testament Interpretation")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Fuller Theological Seminary")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Edith M. Humphrey")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body2"
  }, [_vm._v("William F. Orr Professor of New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Pittsburgh Theological Seminary")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Charles Raith II")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Vice President of Mission Integration")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Mercy Health System")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Christopher R. Seitz")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Senior Research Professor")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Wycliffe College, University of Toronto")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Robert W. Wall")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Paul T. Walls Professor of Scripture and Wesleyan Studies")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Seattle Pacific University and Seminary")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1a"
  }, [_vm._v("Jens Zimmermann")]), _vm._v(" "), _c('p', {
    staticClass: "Body2"
  }, [_vm._v("Canada Research Professor of Interpretation, Religion, and Culture, Trinity Western University, and Visiting Professor of Philosophy, Literature, and Theology, Regent College")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543647ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contributors.vue
// module id = 69
// module chunks = 0